import { Loader } from "./Loader";
import { Geometry } from "./Geometry";
import { mat4 } from "gl-matrix";
import { Source } from "./Source";
import { InputCollection } from "./InputCollection";
import { VertexWeightContainer } from "./VertexWeightContainer";

export class Skin {

    public geometry: Geometry;
    public bindShapeMatrix: mat4;
    public sources: Source[];
    public joints: InputCollection;
    public vertexWeights: VertexWeightContainer;

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let geoReference = dataView.getInt32(offset, true);
        offset += 4;

        this.geometry = loader.getBlob<Geometry>(geoReference);
        this.geometry.skin = this;

        let floatListResult = loader.util.readFloatList(dataView, offset);
        this.bindShapeMatrix = floatListResult.mat4();

        offset = floatListResult.offset;


        let listResult = loader.util.readIdentityList<Source>(dataView, offset);
        this.sources = listResult.items;
        offset = listResult.offset;

        let inputsReference = dataView.getInt32(offset, true);
        offset += 4;

        this.joints = loader.getBlob<InputCollection>(inputsReference);

        let vertexWeigtReference = dataView.getInt32(offset, true);
        offset += 4;

        this.vertexWeights = loader.getBlob<VertexWeightContainer>(vertexWeigtReference);
    }
}
